// This component is used on the underwriting page for questions that have radio button options.
// It handles the shared logic of rendering radio buttons, allowing users to select an option, and showing a single option label when there is only one option available.
// The following components currently use this component: CyberInsurance, EPLI, ContractorTools and WorkplaceViolence.
import React from 'react';
import { LabelLarge } from '../../../elements';
import { SubQuestionCont, UnderwritingRadioBtn, UnderwritingRadioGroupContainer } from '../styles/endorsements';

interface RadioOption {
  label: string;
  value: string | number;
}

interface UnderwritingRadioGroupProps {
  questionCopy: string;
  singleOptionCopy?: string;
  options: RadioOption[];
  selectedValue?: string | number;
  onChange: (value: string) => void;
  name: string;
  isActive?: boolean;
}

const UnderwritingRadioGroup = ({
  questionCopy,
  singleOptionCopy,
  options,
  selectedValue,
  onChange,
  name,
  isActive = true,
}: UnderwritingRadioGroupProps) => {
  const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const showSingleOptionLabel = options.length === 1 && singleOptionCopy;

  return (
    <SubQuestionCont isActive={isActive} direction="column">
      <UnderwritingRadioGroupContainer>
        <LabelLarge htmlFor={name}>
          {showSingleOptionLabel ? `${singleOptionCopy}: ${options[0].label}` : questionCopy}
        </LabelLarge>
        {(!showSingleOptionLabel || !singleOptionCopy) &&
          options.map((option) => (
            <UnderwritingRadioBtn
              id={option.value}
              key={option.value}
              onChange={handleSelect}
              isChecked={selectedValue == option.value}
              labelText={option.label}
              dataCy={option.value as string}
              name={option.label}
            />
          ))}
      </UnderwritingRadioGroupContainer>
    </SubQuestionCont>
  );
};

export default UnderwritingRadioGroup;
